import { T as C, j as $, K as j } from "./index-2269cfe0.js";
import E from "react";
import { r as B } from "./polished.esm-7edc4d30.js";
import { a as K, b as k, c as D } from "./WCLComponent.styles-68ac5b1f.js";
import { css as T } from "styled-components";
import { E as L } from "./ErrorBoundary-60d80e23.js";
const U = (s) => {
  if (s === 0)
    return T`
      box-shadow: none;
    `;
  if (s === 1)
    return T`
      box-shadow: 0px 8px 19px 0px ${B(j, 0.12)};
    `;
  if (s === 2)
    return T`
      box-shadow: 0px 9px 46px 0px ${B(j, 0.12)};
    `;
}, q = C(/* @__PURE__ */ E.forwardRef(function({ children: f, className: x, testId: r, tabIndex: t, onClick: n, onScroll: e, onMouseDown: i, onMouseMove: a, onMouseLeave: p, onMouseUp: d, onTouchCancel: c, onTouchEnd: h, onTouchMove: u, onTouchStart: m, ariaExpanded: l, role: b, domProps: w }, M) {
  return /* @__PURE__ */ $.jsx("div", {
    "data-testid": r,
    className: x,
    tabIndex: t,
    onClick: n,
    onMouseDown: i,
    onMouseMove: a,
    onMouseLeave: p,
    onMouseUp: d,
    onTouchCancel: c,
    onTouchEnd: h,
    onTouchMove: u,
    onTouchStart: m,
    "aria-expanded": l,
    ref: M,
    role: b,
    onScroll: e,
    ...w,
    children: f
  });
}))`
  ${K}
  ${k}
  ${({ elevation: s = 0 }) => U(s)}
  ${D}
`, J = /* @__PURE__ */ E.forwardRef(function({ testId: f = "box", children: x, onClick: r, onMouseDown: t, onMouseUp: n, onMouseLeave: e, onMouseMove: i, onTouchCancel: a, onTouchEnd: p, onTouchMove: d, onTouchStart: c, elevation: h = 0, ...u }, m) {
  const l = (o) => {
    o.persist(), r && r(o);
  }, b = (o) => {
    o.persist(), t && t(o);
  }, w = (o) => {
    o.persist(), n && n(o);
  }, M = (o) => {
    o.persist(), e && e(o);
  }, S = (o) => {
    o.persist(), i && i(o);
  }, y = (o) => {
    o.persist(), a && a(o);
  }, R = (o) => {
    o.persist(), p && p(o);
  }, g = (o) => {
    o.persist(), d && d(o);
  }, v = (o) => {
    o.persist(), c && c(o);
  };
  return /* @__PURE__ */ $.jsx(L, {
    children: /* @__PURE__ */ $.jsx(q, {
      testId: f,
      onMouseUp: w,
      onMouseDown: b,
      onClick: l,
      onMouseLeave: M,
      onMouseMove: S,
      onTouchCancel: y,
      onTouchEnd: R,
      onTouchMove: g,
      onTouchStart: v,
      elevation: h,
      ...u,
      ref: m,
      children: x
    })
  });
});
export {
  J as Box
};
